/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The API error code. See Confluence for more details.
 */
export enum ApiErrorCode {
    UNKNOWN_ERROR = 10000,
    INVALID_USER_DATA = 10001,
    EMAIL_VERIFICATION_FAILED = 10002,
    INVALID_LOGIN_CREDENTIALS = 10003,
    INVALID_TOKEN = 10004,
    DATA_VALIDATION_FAILED = 10005,
    STORAGE_INTERNAL_ERROR = 10006,
    EXTERNAL_SERVICE_ERROR = 10008,
    PERMISSION_DENIED = 10009,
    QUESTIONNAIRE_ANSWERS_NOT_FOUND = 10010,
    INELIGIBLE_FOR_SUBSCRIPTION = 10011,
    SUBSCRIPTION_NOT_FOUND = 10012,
    SUBSCRIPTION_ITEM_NOT_FOUND = 10013,
    SUBSCRIPTION_ITEM_CANNOT_BE_ADDED = 10014,
    SUBSCRIPTION_INVALID_INTERVAL = 10015,
    PURCHASE_ITEM_NOT_FOUND_IN_PROVIDER = 10016,
    ADDRESS_NOT_FOUND = 10017,
    AVATAR_NOT_FOUND = 10018,
    INVALID_API_TOKEN = 10019,
    NO_DEFAULT_PAYMENT_METHOD = 10020,
    USER_LIFELINE_ITEM_NOT_SUPPORTED = 10021,
    USER_LIFELINE_ITEM_INVALID_STRUCTURE = 10022,
    SUBSCRIPTION_COUPON_DOES_NOT_EXIST = 10023,
    PAYMENT_METHOD_NOT_FOUND = 10024,
    MFA_REQUIRED = 10025,
    PAYMENT_CHARGE_ERROR = 10026,
    QUESTIONNAIRE_NOT_FOUND = 10027,
    QUESTIONNAIRE_ANSWERS_TYPE_INVALID = 10028,
    MFA_INVALID_TOKEN = 10029,
    MFA_INVALID_SECRET = 10030,
    EMAIL_VERIFICATION_REQUIRED = 10031,
    INTERVAL_CHANGE_NOT_ALLOWED_FOR_ONE_TIME_SUBSCRIPTION = 10032,
    SUBSCRIPTION_INVALID_STATUS_TO_BUY = 10033,
    EXTERNAL_ENTITY_NOT_FOUND = 10034,
    PATIENT_NOTE_NOT_FOUND = 10035,
    SUBSCRIPTION_COUPON_INVALID = 10036,
    REFERRAL_COUPON_NOT_EXISTS_FOR_AUTHENTICATED_USER = 10038,
    SUBSCRIPTION_REFERRAL_COUPON_NOT_FOUND_FOR_CODE = 10040,
    ILLEGAL_ITEM_QUANTITY_VALUE = 10042,
    SUBSCRIPTION_CHANGE_STATUS_FAILED = 10045,
    STATE_NOT_FOUND = 10046,
    UNABLE_TO_TRIGGER_LAB_ORDER = 10047,
    UNABLE_TO_PLACE_LAB_ORDER = 10048,
    SUBSCRIPTION_ITEM_EXPIRATION_FORBIDDEN = 10049,
    SCHEDULED_TASK_NOT_FOUND = 10050,
    USER_LIFELINE_ITEM_NOT_FOUND = 10051,
    USER_IS_NOT_SUBSCRIBED_TO_LAB_TESTS = 10052,
    NO_STANDING_LAB_ORDER_AVAILABLE = 10054,
    UNAVAILABLE_LAB_ORDER_PROVIDER = 10055,
    LAB_ORDER_NOT_FOUND = 10056,
    LAB_ORDER_PROVIDER_UPDATE_FAILED = 10057,
    EMAIL_NOT_AVAILABLE = 10058,
    PASSWORD_REUSE_NOT_ALLOWED = 10059,
    UNABLE_TO_DOCUMENT_LAB_ORDER = 10060,
    PASSWORD_EXPIRED = 10061,
    EMAIL_VERIFICATION_CODE_EXPIRED = 10062,
    MEDICATION_RENEWAL_NOT_FOUND = 10063,
    MEDICATION_RENEWAL_ERROR = 10064,
    RATE_LIMIT_EXCEEDED = 10065,
    SUBSCRIPTION_INVALID_STATUS_TO_UPDATE_ITEM = 10066,
    MEDICATION_NOT_FOUND = 10067,
    SUBSCRIPTION_CONCURRENT_MODIFICATION = 10068,
    MEDICATION_DOSAGE_NOT_FOUND = 10069,
    MEDICATION_PRESCRIPTION_OPTION_NOT_FOUND = 20001,
    STRIPE_SIGNATURE_VERIFICATION_FAILED = 20002,
    STRIPE_INVALID_DATA = 20003,
    STRIPE_UNEXPECTED_EVENT = 21001,
    TRUEPILL_INVALID_DATA = 21002,
    TRUEPILL_MISSED_CALLBACK_TYPE = 21003,
    TRUEPILL_CONSULTATION_NOT_FOUND = 21004,
    TRUEPILL_UNKNOWN_STATUS = 21005,
    TRUEPILL_PRESCRIPTION_NOT_FOUND = 21006,
    TRUEPILL_PRESCRIPTION_ALREADY_EXISTS = 21008,
    TRUEPILL_FOLLOWUP_CONSULTATION_CREATION_IMPOSSIBLE = 21009,
    TRUEPILL_CANNOT_FETCH_CLINICAL_PROTOCOL = 32001,
    DETECTED_ISSUE_INVALID = 32002,
    DETECTED_ISSUE_ALREADY_MITIGATED = 32003,
    DETECTED_ISSUE_NOT_FOUND = 32004,
    DETECTED_ISSUE_INVALID_V3_ACT_CODE = 32005,
    MITIGATION_TYPE_NOT_FOUND = 32006,
    SHIPMENT_CANCELLATION_FAILED = 32007,
    SHIPMENT_NOT_FOUND = 32008,
    SUBSCRIPTION_INVALID_STATUS_TO_REMOVE_ITEM = 32009,
    SUBSCRIPTION_INVALID_STATUS_TO_ADD_ITEM = 32010,
    PRESCRIPTION_NOT_FOUND = 32011,
    CANCEL_LAB_ORDER_FAILED = 32012,
    CANNOT_ASSIGN_PROVIDER_TO_CONSULTATION = 32013,
    PROVIDER_ALREADY_ASSIGNED_TO_CONSULTATION = 32014,
    UNASSIGNING_PROVIDER_FAILED = 32015,
    MARK_LAB_ORDER_AS_COMPLETED_FAILED = 32016,
    CANNOT_COMPLETE_CONSULTATION = 32017,
    CONSULTATION_NOT_FOUND = 32018,
    PROVIDER_NOT_FOUND = 32019,
    USER_NOT_FOUND = 32020,
    DOSESPOT_INVALID_DATA = 32021,
    DOSESPOT_CANNOT_FETCH_PHARMACIES = 32022,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT = 32023,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_CLINICIAN = 32024,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT_SELF_REPORTED_MEDS = 32025,
    DOSESPOT_UNKNOWN_STATUS = 32026,
    DOSESPOT_CANNOT_CREATE_OR_UPDATE_PATIENT_SELF_REPORTED_ALLERGIES = 32027,
    DOSESPOT_CANNOT_ADD_PATIENT_PRESCRIPTION = 32028,
    DOSESPOT_CANNOT_SEND_PATIENT_PRESCRIPTION = 32029,
    SUBSCRIPTION_INVALID_STATUS_TO_ADD_LAB_ITEM = 32030,
    SUBSCRIPTION_INVALID_LAB_ITEM = 32031,
    MARK_LAB_ORDER_AS_DECLINED_FAILED = 32033,
    TRUEPILL_CANNOT_CREATE_OR_UPDATE_PATIENT = 32037,
    CONSULTATION_CARE_PLAN_ACTION_CANNOT_BE_ADDED = 32038,
    INVALID_PROVIDER_TO_MODIFY_CONSULTATION = 32039,
    PRESCRIPTION_PROVIDER_SPECIFIC_INFO_NOT_FOUND = 32040,
    INVALID_NUMBER_OF_PRIMARY_BENEFITS = 32041,
    CARE_PLAN_ACTIONS_DEFINED_FOR_NOT_TAKEN_ITEMS = 32042,
    DUPLICATED_CARE_PLAN_ACTIONS_DEFINED_FOR_THE_SAME_MEDICATIONS = 32043,
    CONSULTATION_IN_PROGRESS_FOR_PATIENT = 32044,
    CANNOT_FETCH_PRESCRIPTION_DETAILS = 32045,
    FEATURE_INACTIVE = 32046,
    DOSESPOT_CANNOT_FIND_CLINICIAN_OR_PRESCRIBING_AGENT = 32047,
    DOSESPOT_CANNOT_FIND_PATIENT = 32048,
    SUBSCRIPTION_INVALID_ITEM_METADATA = 32049,
    DOSESPOT_CANNOT_FETCH_NOTIFICATIONS_COUNT = 32050,
    PHARMACY_INFORMATION_NOT_FOUND = 32051,
    ACTION_FOR_NINE_AM_MED_WITHOUT_DAYS_OF_SUPPLY = 32052,
    ACTION_FOR_NINE_AM_MED_WITHOUT_DAILY_DOSAGE = 32053,
    ACTION_FOR_ITEM_WRONG_QUANTITY = 32054,
    COULD_NOT_READ_REQUEST = 32055,
    CANNOT_REPORT_CONSULTATION_ISSUE = 32056,
    CANNOT_CANCEL_CONSULTATION = 32057,
    CONSULTATION_CANNOT_BE_MODIFIED = 32058,
    DOSESPOT_DIAGNOSIS_SEARCH_FAILED = 32060,
    ACTIONS_DEFINED_FOR_UNKNOWN_SUPPLY_NDCS = 32061,
    LAB_ORDER_UPDATE_FAILED = 32062,
    DOSESPOT_PRESCRIPTION_REFRESH_FAILED = 32063,
    ADDRESS_COORDINATES_NOT_FOUND = 32064,
    PHARMACY_INFORMATION_INVALID_ID_FORMAT = 32065,
    CONSULTATION_CANNOT_BE_CREATED_BECAUSE_OF_PENDING_ISSUES = 32066,
    CONSULTATION_REASON_ERROR = 32067,
    CANNOT_CREATE_CHANGE_HEALTHCARE_LAB_ORDER_SUMMARY_URL = 32068,
    PCP_CANNOT_BE_FOUND = 32069,
    CANNOT_STORE_LAB_ORDER_REQUISITION = 32070,
    CHANGE_HEALTHCARE_API_DATA_RECEIVED_ERROR = 32071,
    CONSULTATION_COMPLETED_LIFELINE_ITEM_ALREADY_EXISTS = 32072,
    CANNOT_FETCH_PROVIDER_INFO = 32073,
    CANNOT_CREATE_CLINICAL_SUMMARY = 32074,
    INVALID_FAX_DATA = 32075,
    FAX_SENDING_FAILED = 32076,
    GETLABS_CANNOT_PARSE_WEBHOOK = 32077,
    CANNOT_ASSIGN_CARE_TEAM_USER_TO_CONSULTATION = 32078,
    CANNOT_UNASSIGN_CARE_TEAM_USER_FROM_CONSULTATION = 32079,
    PROVIDER_NOT_ASSIGNED_TO_CONSULTATION = 32080,
    CONSULTATION_CANNOT_BE_REACTIVATED_IN_GIVEN_STATUS = 32081,
    CANNOT_DEFINE_GIVEN_ACTION_MORE_THAN_ONCE = 32082,
    SUBSCRIPTION_MOST_RECENT_PERIODIC_NOT_FOUND = 32083,
    SUBSCRIPTION_UPDATE_ITEM_EXPIRATION_DATE_FAILED = 32084,
    ILLEGAL_ITEM_INITIAL_APPLICATION_DATE_BEFORE_MEDICATION_START = 32085,
    ILLEGAL_FUTURE_ITEM_INITIAL_APPLICATION_DATE = 32086,
    ILLEGAL_ITEM_TYPE_FOR_INITIAL_APPLICATION_DATE = 32087,
    CONSULTATION_CANNOT_BE_ACTIVATED_IN_GIVEN_STATUS = 32088,
    CONSULTATION_CANNOT_BE_ACTIVATED_BECAUSE_OF_PENDING_ISSUES = 32089,
    CONSULTATION_CANNOT_BE_ACTIVATED_BECAUSE_OF_MISSING_TAKE_CONSULTATION_NOTES = 32090,
    INVALID_CARE_TEAM_TO_MODIFY_CONSULTATION = 32091,
    NO_CARE_TEAM_ASSIGNED = 32092,
    CONSULATION_NO_PROVIDER_ASSIGNED = 32093,
    UNSUPPORTED_CARE_PLAN_ACTION = 32094,
    COMPLETED_CONSULTATION_WITH_UNFINISHED_FOLLOW_UP_ACTIONS_EXISTS = 32095,
    CANNOT_COMPLETE_ORDER_ONLY_CONSULTATIONS_IN_BULK = 32096,
    CANNOT_CREATE_CONSULTATION_FOR_PATIENT_WITHOUT_MANDATORY_PROFILE_ATTRIBUTES = 32097,
    CANNOT_CREATE_CONSULTATION_FOR_PATIENT_WITHOUT_ACTIVE_SUBSCRIPTION = 33001,
    TASKS_TASK_NOT_FOUND = 33002,
    TASKS_TASK_STATUS_UPDATE_NOT_ALLOWED = 33101,
    MESSAGING_MESSAGE_NOT_FOUND = 33200,
    SMS_AWS_CANNOT_PARSE_WEBHOOK = 33201,
    SMS_AWS_UNKNOWN_NOTIFICATION_TYPE = 33202,
    SMS_PHONE_NUMBER_NOT_FOUND_FOR_USER = 33203,
    SMS_PHONE_NUMBER_ALREADY_VERIFIED_FOR_USER = 33204,
    SMS_MISSING_PHONE_NUMBER_VERIFICATION_NOTE = 33301,
    FILE_NOT_FOUND = 33302,
    FILE_NOT_AVAILABLE = 33303,
    UNSUPPORTED_FILE_TYPE = 33304,
    FILE_TOO_LARGE = 33400,
    CUSTOMERIO_INVALID_REQUEST_DATA = 33401,
    CUSTOMERIO_INVALID_SIGNATURE = 33402,
    CUSTOMERIO_INVALID_SIGNATURE_CONFIGURATION = 33403,
    CUSTOMERIO_USER_NOT_FOUND = 33404,
    CUSTOMERIO_COULD_NOT_READ_MESSAGE = 33500,
    BENEFITS_MEDICATION_PRIOR_AUTHORIZATION_NOT_FOUND = 33501,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_TYPE_TO_ADD_APPEAL = 33502,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_STATUS_TO_ADD_APPEAL = 33503,
    BENEFITS_APPEAL_LIMIT_FOR_MEDICATION_PRIOR_AUTHORIZATION_EXCEEDED = 33504,
    BENEFITS_TERMINAL_FOR_MEDICATION_PRIOR_AUTHORIZATION_CANT_BE_CHANGED = 33505,
    BENEFITS_VALID_UNTIL_DATE_FOR_MEDICATION_PRIOR_AUTHORIZATION_STATUS_CHANGE_IS_REQUIRED = 33506,
    BENEFITS_MEDICATION_NOT_FOUND_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33507,
    BENEFITS_EMPTY_MEDICATION_PROVIDED_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33508,
    BENEFITS_EMPTY_APPEAL_FOR_AND_MEDICATION_PROVIDED_FOR_MEDICATION_PRIOR_AUTHORIZATION = 33509,
    BENEFITS_INVALID_MEDICATION_PRIOR_AUTHORIZATION_INITIAL_STATUS = 33510,
    BENEFITS_BENEFIT_EXISTS = 33511,
    BENEFITS_BENEFIT_DOES_NOT_EXIST = 33601,
    DEVICE_NOT_FOUND = 33602,
    DEVICE_IN_USE = 33603,
    DEVICE_INVALID_DATA = 33701,
    SMARTMETERRPM_INVALID_DATA = 33702,
    SMARTMETERRPM_INVALID_SIGNATURE = 33703,
    SMARTMETERRPM_INVALID_SIGNATURE_CONFIGURATION = 33801,
    LILLY_USER_NOT_FOUND = 33802,
    LILLY_PATIENT_NOT_FOUND = 33803,
    LILLY_INSUFFICIENT_DATA = 33901,
    USER_LIFELINE_ITEM_DELETED = 33902,
    USER_LIFELINE_ITEM_DELETE_NOT_PERMITTED = 34001,
    QUESTIONNAIRE_SESSION_NOT_FOUND = 34002,
    QUESTIONNAIRE_SESSION_COMPLETED = 34003,
    QUESTIONNAIRE_VARIABLE_PROVIDER_FAILED_DUE_TO_PROVIDER_SPECIFIC_ERROR = 34004,
    QUESTIONNAIRE_SESSION_NOT_AVAILABLE = 34100,
    ELIGIBILITY_COULD_NOT_BE_CHECKED = 34101,
    ELIGIBILITY_CHECK_FAILED_DUE_TO_TECH_ERROR = 34102,
    PARTNER_INELIGIBLE_FOR_SUBSCRIPTION = 34103,
    EMPLOYER_NOT_COVERED_BY_PLAN = 34104,
    EMPLOYER_REQUIRED_BY_PLAN = 34200,
    SFTP_TO_GO_INVALID_DATA = 34201,
    SFTP_TO_GO_INVALID_SIGNATURE = 34202,
    SFTP_TO_GO_INVALID_SIGNATURE_CONFIGURATION = 34300,
    CONNECTIVE_HEALTH_NO_PATIENT_PROCESSING = 34301,
    CONNECTIVE_HEALTH_PROCESSING_REQUESTED_TOO_SOON = 34302,
    CONNECTIVE_HEALTH_FAILED_INCOMPLETE_PATIENT_DATA = 34303,
    CONNECTIVE_HEALTH_FAILED_INVALID_PATIENT_DATA = 34401,
    SHIPMENT_CANNOT_BE_INITIATED = 34402,
    SHIPMENT_STATUS_UPDATE_NOT_ALLOWED = 34403,
    SHIPMENT_CANCELLATION_NOT_SUPPORTED = 34501,
    CONSENT_DOCUMENT_NOT_FOUND = 34601,
    DIAGNOSIS_ALREADY_EXIST = 34602,
    DIAGNOSIS_PATIENT_HAS_CONSULTATION_ONGOING = 34701,
    ZENDESK_UNSUPPORTED_WEBHOOK = 34801,
    FEEDBACK_HAS_BEEN_PROVIDED = 34802,
    AI_MISSING_DATA = 34803,
    AI_INTERNAL_ERROR = 34804,
    AI_INVALID_INPUT_PROVIDED = 34900,
    PHARMACY_BENEFIT_UNKNOWN_PARTNER_ID = 34901,
    RXDIET_USER_ALREADY_EXISTS = 34902,
    RXDIET_USER_CREDENTIALS_NOT_FOUND = 34903,
    RXDIET_CANNOT_CREATE_USER = 34904,
    RXDIET_USER_NOT_FOUND = 35000,
    SUBSCRIPTION_INVALID_STATUS_TO_FINISH = 35001,
    SUBSCRIPTION_INVALID_STATUS_TO_REACTIVATE = 35002,
    SUBSCRIPTION_PLAN_NOT_FOUND = 35003,
    INITIAL_SUBSCRIPTION_NOT_FOUND = 35004,
    SUBSCRIPTION_CANNOT_BE_PAUSED = 35005,
    SUBSCRIPTION_CANNOT_BE_UNPAUSED = 35006,
    SUBSCRIPTION_RECURRING_PAYMENT_ALREADY_ACTIVE = 35007,
    INVALID_MEDICATION_ITEM_FOR_INITIAL_APPLICATION_DATE = 35008,
    SUBSCRIPTION_PLAN_NOT_ALLOWED = 35009,
    SUBSCRIPTION_PLAN_CHANGE_NOT_ALLOWED = 35100,
    RPM_STATUS_NOT_AVAILABLE = 35101,
    CONCIERGE_CARE_NOT_AVAILABLE_FOR_EMPLOYER = 35102,
    MEDICATION_CONTINUATION_ERROR = 35200,
    APPOINTMENT_NOT_FOUND = 35201,
    APPOINTMENT_CANNOT_BE_RESCHEDULED = 35202,
    PROSPECTIVE_APPOINTMENT_CANNOT_BE_CREATED = 35203,
    PROSPECTIVE_APPOINTMENT_CANNOT_BE_CANCELED = 35204,
    APPOINTMENT_SCHEDULING_CONFLICT = 35205,
    APPOINTMENT_PARTICIPANTS_NOT_FOUND = 35206,
    APPOINTMENT_LIMIT_EXCEEDED = 35207,
    APPOINTMENT_INVALID_DATA = 35208,
    APPOINTMENT_SCHEDULING_PRECONDITION_NOT_FULFILLED = 35209,
    APPOINTMENT_TYPE_DEPRECATED = 35210,
    APPOINTMENT_VIDEO_CALL_IN_PROGRESS = 35300,
    OBSERVATION_INVALID_DATE_RANGE = 35301,
    OBSERVATION_INVALID_DATE = 35302,
    CANNOT_FIND_OBSERVATION_BUNDLE = 35401,
    ALLERGY_INTOLERANCE_ALREADY_EXIST = 35402,
    ALLERGY_INTOLERANCE_NOT_FOUND = 35501,
    TREATMENTPLAN_UNKNOWN_TARGET = 35601,
    PRESCRIPTION_MEDICATION_NOT_FOUND = 35602,
    INTAKE_LOG_NOT_FOUND = 35603,
    LAST_INTAKE_DATE_BEFORE_PRESCRIPTION = 35701,
    ZOOM_WEBHOOK_VERIFICATION_FAILED = 35801,
    MESSAGE_DRAFT_NOT_FOUND = 35802,
    MESSAGE_DRAFT_MISSING_INPUT_DATA = 35803,
    MESSAGE_DRAFT_NOT_ALLOWED = 35901,
    CANNOT_GENERATE_INSIGHTS = 35902,
    INSIGHTS_NOT_FOUND = 35903,
    INSIGHT_REFINEMENT_SUPERSEDED = 36001,
    SOLERA_API_REQUEST_FAILED = 36002,
    SOLERA_NO_USER_FOUND = 36101,
    NOT_READY_FOR_DELETION = 36201,
    WITHINGS_ORDER_NOT_FOUND = 36202,
    WITHINGS_SUPPORTED_DEVICE_NOT_FOUND = 36203,
    WITHINGS_API_ERROR = 36204,
    WITHINGS_TOKEN_NOT_FOUND = 36205,
    WITHINGS_DEVICE_LINK_CONFLICT = 36301,
    CONVERSATION_NOT_FOUND = 36302,
    CONVERSATION_MESSAGE_NOT_FOUND = 36303,
    CONVERSATION_CLOSED = 36304,
    CONVERSATION_ALREADY_ESCALATED = 36305,
    ESCALATION_NOT_FOUND = 36306,
    CONVERSATION_MISSION_NOT_FOUND = 36307,
    CONVERSATION_MISSION_NOT_ACTIVE = 36308,
    CONVERSATION_MISSION_NO_ACTIVE_SUBSCRIPTION = 36401,
    TAKE_CONSULTATION_NOTES_ACTION_NOT_DEFINED_FOR_SYNC_CONSULT = 36402,
    CANNOT_CREATE_CONSULTATION_FOR_PEDIATRIC_PATIENT_WITH_MISSING_ATTRIBUTES = 36403,
    CONSULTATION_CANNOT_CREATE_LIFELINE_ITEM_FOR_NOT_COMPLETED_CONSULTATION = 36404,
    CONSULTATION_CANNOT_GENERATE_LIFELINE_ITEM_FOR_NOT_ACTIVE_CONSULTATION = 36501,
    WEBSOCKET_EMPTY_PAYLOAD = 37101,
    CONSISTENCY_SCORE_NOT_FOUND = 38001,
    LAB_AUTO_EXTRACTION_NOT_FOUND = 38002,
    LAB_ORDER_REVIEW_NOT_FOUND = 38101,
    KNOWLEDGE_DOCUMENT_NOT_FOUND = 38102,
    KNOWLEDGE_DOCUMENT_INVALID_METADATA = 38103,
    KNOWLEDGE_SEARCH_API_KEY_NOT_CONFIGURED = 38104,
    KNOWLEDGE_SEARCH_PAGE_OUT_OF_RANGE = 38201,
    MACRO_NOT_FOUND = 39001,
    NOTIFICATION_MESSAGE_NOT_FOUND = 40001,
    LYRA_CONSENT_INACTIVE = 40002,
    LYRA_PATIENT_DATA_NOT_FOUND = 40101,
    PROVIDER_ALREADY_EXISTS_FOR_USER = 40102,
    PROVIDER_NPI_IN_USE = 40201,
    CLINICAL_EXCEPTION_PAYER_REQUIRED = 40202,
    CLINICAL_EXCEPTION_PAYER_UNSUPPORTED = 40203,
    CLINICAL_EXCEPTION_NO_QUALIFYING_CONDITION_FOUND = 41001,
    CASES_CASE_NOT_FOUND = 41002,
    CASES_VIEW_NOT_FOUND = 41003,
    CASES_GROUP_NOT_FOUND = 41004,
    CASES_GROUP_NOT_EMPTY = 41005,
    CASES_ASSIGNEE_NOT_IN_GROUP = 41006,
    CASES_VIEW_INVALID_FILTER = 41007,
    CASES_VIEW_NAME_CONFLICT = 41008,
    CASES_GROUP_NAME_CONFLICT = 41009,
    CASES_TAG_NAME_CONFLICT = 41010,
    CASES_DEFAULT_GROUP_DELETION = 41011,
    CASES_DEFAULT_GROUP_NOT_CONFIGURED = 41012,
    CASES_TAG_NOT_FOUND = 41013,
    CASES_INVALID_LINK = 41014,
    CASES_ASSIGNMENT_REQUIRED = 41015,
    CASES_KNOWN_GROUP_DELETION = 41016,
    CASES_LOCKED_BY_ANOTHER_USER = 41017,
    CASES_VIEW_INVALID_ROLE = 41018,
    CASES_GROUP_REFERENCED_BY_VIEW = 41019,
    CASES_DETAILS_IDENTITY_MISMATCH = 41020,
    CASES_DETAILS_UPDATE_UNSUPPORTED_FOR_TYPE = 41021,
    CASES_DETAILS_MALFORMED = 41022,
    CASES_INVALID_APPOINTMENT = 41023,
    CASES_WITHOUT_MEMBER = 41024,
    CASES_CONVERSATION_MISMATCH = 41025,
    CASES_CONVERSATION_ESCALATED_ELSEWHERE = 41026,
    CASES_CLOSED = 41027,
    CASES_MANAGEMENT_DISABLED = 41101,
    REMINDER_NOT_FOUND = 42001,
    GOOGLE_ACCOUNT_NOT_FOUND = 42002,
    GOOGLE_AUTHORIZATION_REVOKED = 42003,
    GOOGLE_OAUTH_ERROR = 42004,
    GOOGLE_ACCOUNT_ALREADY_LINKED = 42005,
    GOOGLE_IDENTITY_SCOPES_MISSING = 42006,
    GOOGLE_REFRESH_TOKEN_MISSING = 43001,
    TRANSCARENT_MEMBER_ID_ALREADY_LINKED = 43002,
    TRANSCARENT_MEMBER_LINK_NOT_FOUND = 44001,
    EXTERNAL_IDENTITY_NOT_FOUND = 44002,
    EXTERNAL_IDENTITY_ALREADY_LINKED = 44003,
    EXTERNAL_IDENTITY_INVALID = 44004,
    EXTERNAL_IDENTITY_SYSTEM_UNAVAILABLE = 44005,
    EXTERNAL_IDENTITY_UNLINK_UNSUPPORTED = 44006,
    EXTERNAL_IDENTITY_OPERATION_UNSUPPORTED = 44007,
    EXTERNAL_IDENTITY_LINKED_TO_ANOTHER_USER = 45001,
    SIMULATED_DATA_ALREADY_EXISTS = 46001,
    SCHEDULING_PROFILE_NOT_FOUND = 46002,
    SCHEDULING_PROFILE_ALREADY_EXISTS = 46003,
    SCHEDULING_PROFILE_INVALID = 46004,
    SCHEDULING_AVAILABILITY_NOT_FOUND = 46005,
    SCHEDULING_CALENDAR_NOT_CONNECTED = 46006,
    SCHEDULING_PREVIEW_RANGE_INVALID = 46007,
}
